<template>
  <div class="FilterDisplay">
    <Select
      :options="options"
      :placeholder="placeholder"
      v-model="selected"
      @change="onInput"
    />
  </div>
</template>

<script>
import { Select } from 'daas-components';

import EventBus from '@/utils/eventBus';

export default {
  name: 'FilterDisplay',
  data(){
    return{
    selected:''
    }
  },
  components: {
    Select,
  },
  methods: {
    onInput(value) {
      EventBus.$emit('ON_DATE_ADVERTISEMENTS', value);
      EventBus.$emit('ON_DATE_BUSINESS', value);
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    placeholder:{
      type: String,
      required: true,
      default: () => ('placeholder'),
    },
    options: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
};
</script>

<style lang="scss">
.FilterDisplay {
  margin-left: rem(100);
  &__Tittle {
    color: $primary;
    font-size: rem(16);
  }
  &__Select {
    width: 100%;
    height: rem(40);
    background: $white;
    border: rem(1px) solid $white-700;
    min-width: rem(100);
    color: $primary;
    font-size: rem(16);
    padding-left: rem(10);
  }
  &__Select:focus {
    outline: none;
  }
  &__Select option:checked {
    background: #e9edf2;
  }
}
</style>
